import { Alert, Collapse, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { Box } from "@mui/system";
import {
  BannerSeverity,
  BannerVariant,
} from "../../../Common/utils/bannerMapping";
import React from "react";
import { useBannerDismiss } from "./hooks/useBannerDismiss";
import { sanitizeHtml } from "../../../Common/utils/sanitazeUtils";

interface IAlertBannerProps {
  id: string;
  text: string;
  severity?: BannerSeverity;
  variant?: BannerVariant;
  isActive: boolean;
  customBackgroundColor?: string;
  previewMode?: boolean;
}

const AlertBanner = ({
  id,
  text,
  severity,
  variant,
  isActive,
  customBackgroundColor,
  previewMode,
}: IAlertBannerProps): JSX.Element => {
  const { open, dismiss } = useBannerDismiss(id, text, isActive);

  const htmlContent = React.createElement("div", {
    dangerouslySetInnerHTML: { __html: sanitizeHtml(text) },
  });

  return (
    <Box sx={{ width: "100%" }}>
      <Collapse in={open}>
        <Alert
          severity={severity ?? "info"}
          variant={variant ?? "standard"}
          sx={(theme) => ({
            backgroundColor: customBackgroundColor,
            color:
              variant === "filled"
                ? theme.palette[severity ?? "info"].contrastText
                : undefined,
          })}
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={previewMode ? undefined : dismiss}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          }
        >
          {previewMode && !htmlContent
            ? "Enter text above to see preview"
            : htmlContent}
        </Alert>
      </Collapse>
    </Box>
  );
};

export default AlertBanner;
